// extracted by mini-css-extract-plugin
export default {"exclusivityCheckbox":"exclusivityCheckbox-b18d"};